import { render, staticRenderFns } from "./MovementsPage.vue?vue&type=template&id=33390608&"
import script from "./MovementsPage.vue?vue&type=script&lang=js&"
export * from "./MovementsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports